import * as axios from "axios";
import {
  getAuthHeader,
  getUploadFileHeader,
  removeAllCookies,
} from "./../utils";

export const addFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFileTimeLine = (fileNumber: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/timeline/${fileNumber}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};
export const getFileSheetType = (fileCode:any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/sheet-type/${fileCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      console.error('Error fetching sheet type:', error);
      throw error;
    }
  );
};

export const reintiateParkedFile = (fileNumber: any, model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}re-intiate-file/${fileNumber}`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFileDetailsByfileName = (fileNumber: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file-details/${fileNumber}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getAllFileList = (userCode: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}get/files/${userCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFileListDeptWise = (fileCode: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/list/dept/${fileCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

const addEfile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}add/efile`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getfilesByFileCode = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}dept/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getfilesByFileName = (fileName: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}parked-file-details/by-name`;
  return axios.post(url, { fileName }, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

const addMedicalClaim = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/claim`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const reOpenFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/re-open`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const reCallFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/re-call`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFileList = (page: number, limit: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/list?p=${page}&l=${limit}`;
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response.data.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};

export const getInitiatedFileList = (page: number, limit: number = 20, search: string = '') => {
  const searchParam = search.trim() ? `&s=${encodeURIComponent(search)}` : '';
  const url = `${process.env.REACT_APP_BASE_URL}file/initiated-list?p=${page}&l=${limit}${searchParam}`;
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response.data.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};

export const getPendingFileList = (page: number, limit: number = 20, search: string = '') => {
  const searchParam = search ? `&s=${encodeURIComponent(search)}` : '';
  const url = `${process.env.REACT_APP_BASE_URL}file/pending-list?p=${page}&l=${limit}${searchParam}`;
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response.data.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};

export const getOtherFileList = (page: number, limit: number = 20, search: string = '') => {
  const searchParam = search ? `&s=${encodeURIComponent(search)}` : '';
  const url = `${process.env.REACT_APP_BASE_URL}file/other-list?p=${page}&l=${limit}${searchParam}`;
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response.data.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};


export const getHodSubmittedFiles = (page: number, limit: number = 20, search: string = '') => {
  const searchParam = search ? `&s=${encodeURIComponent(search)}` : '';
  const url = `${process.env.REACT_APP_BASE_URL}file/hod/submitted-for-approval?p=${page}&l=${limit}${searchParam}`;
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response.data.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};


export const pendingHodFiles = (page: number, limit: number = 20, search: string = '') => {
  const searchParam = search ? `&s=${encodeURIComponent(search)}` : '';
  const url = `${process.env.REACT_APP_BASE_URL}file/hod/pending?p=${page}&l=${limit}${searchParam}`;
  
  return axios
    .get(url, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.response?.data?.error);
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};




export const updateDraftStatus = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/update-draft-status`;

  return axios
    .put(url, model, getAuthHeader())
    .then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(
          error.response?.data?.error ||
            "An error occurred while updating draft status."
        );
      }
    )
    .catch((err: any) => {
      console.log("err", err);
    });
};

export const getApprovedFiles = (page: number, limit: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/approved-files?p=${page}&l=${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);

      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getFileWithHOD = () => {
  const url = `${process.env.REACT_APP_BASE_URL}file/with-hod`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFilesPendingWithEmployee = (pageNumber = 1, pageSize = 20, searchKeyword='') => {
  const url = `${process.env.REACT_APP_BASE_URL}file/with-employee?pageNumber=${pageNumber}&pageSize=${pageSize}&searchKeyword=${searchKeyword}`;

  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      // reset to normal
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getFilesPendingWithEmployeeGlobalList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}file/global/with-employee`;

  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      // reset to normal
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getClosedFileList = (
  page: number,
  limit: number,
  parkedBy: String,
  searchTerm: string = '' 
) => {
  let url = `${process.env.REACT_APP_BASE_URL}file/closed?p=${page}&l=${limit}&pb=${parkedBy}`;
  
  if (searchTerm && searchTerm.trim() !== '') {
    url += `&search=${encodeURIComponent(searchTerm.trim())}`;
  }
  
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      // reset in prev state
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getClosedFileGlobalList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}global/file/closed`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      // reset in prev state
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const searchFiles = (keyword: string, page: number, limit: number) => {
  const url = `${
    process.env.REACT_APP_BASE_URL
  }file/search?k=${encodeURIComponent(keyword)}&p=${page}&l=${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const checkFileNumber = (fileNumber: string) => {
  const url = `${
    process.env.REACT_APP_BASE_URL
  }file/check-number?k=${encodeURIComponent(fileNumber)}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getFileDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/detail/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};


export const getFilesByCreationAccess = (model:any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/creation-list`;
  return axios.post(url, model ,getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const dltDocument = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}dlt/upload`;
  return axios
    .post(url, model, getAuthHeader())
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      alert(error.response?.data?.error || "Something went wrong");
    });
};

export const createPrintLog = (printData: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}print-log/create`;
  return axios
    .post(url, printData, getAuthHeader())
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      alert(error.response?.data?.error || "Something went wrong");
    });
};

export const getMedicalFileDetail = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/file/detail/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getMedicalFilesById = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/fileDetail/byId/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getDiscription = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}get/medical/discription/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getMedicalFileStatus = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}get/medical/file/status/byCode/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const uploadAttachment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/attachment`;
  const formData = new FormData();
  formData.append("fileCode", model.fileCode);
  formData.append("deptCode", model.deptCode);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};

export const uploadAttachmentOfFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/attachment-file`;
  const formData = new FormData();
  formData.append("fileCode", model.fileCode);
  formData.append("deptCode", model.deptCode);
  formData.append("attachment", model.attachment);
  formData.append("pageCount", model.pageCount);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};

export const deleteAttachmentOfFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/delete-attachment-file`;

  const formData = new FormData();
  formData.append("fileCode", model.fileCode);
  formData.append("originalFileName", model.originalFileName); // backend will use this
  formData.append("fileName", model.fileName); // backend will use this
  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => response.data)
    .catch((err: any) => ({ error: err.message }));
};

const uploadMedicalAttachment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const formData = new FormData();
  formData.append("fileCode", model.fileCode);
  formData.append("uploadId", model.uploadId);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};

const searchFile = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}search/file`;
  let input = { input: model.input, userCode: model.code };
  return axios.post(url, input, getAuthHeader()).then((response: any) => {
    return response.data;
  });
};

// Step 1: Basic file creation
export const createBasicFile = async (data: any): Promise<any> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}file/basic-file`,
      data,
      getAuthHeader()
    );
    return response.data;
  } catch (error: any) {
    console.error("Error creating basic file:", error);
    throw error;
  }
};

// Step 2: Add recipients and details
export const addFileStep2 = async (
  fileCode: string,
  data: any
): Promise<any> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}file/add-step2/${fileCode}`,
      data,
      getAuthHeader()
    );
    return response.data;
  } catch (error: any) {
    console.error("Error in step 2:", error);
    throw error;
  }
};

// Step 3: Add approvers and final details
export const addFileStep3 = async (
  fileCode: string,
  data: any
): Promise<any> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}file/add-step3/${fileCode}`,
      data,
      getAuthHeader()
    );
    return response.data;
  } catch (error: any) {
    console.error("Error in step 3:", error);
    throw error;
  }
};

const hodApproveFile = async (fileCode: number, data: any): Promise<any> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}file/hod-approve/${fileCode}`,
      data,
      getAuthHeader()
    );

    return response.data;
  } catch (error: any) {
    console.error("Error approving file by HOD:", error);
    throw error;
  }
};


export const getFileCreationReport = (startDate: string, endDate: string, page: number = 1) => {
  const url = `${process.env.REACT_APP_BASE_URL}report/file-creation?startDate=${startDate}&endDate=${endDate}&page=${page}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response?.data?.error || "Something went wrong");
    }
  );
};

export { addEfile, addMedicalClaim, searchFile, uploadMedicalAttachment, hodApproveFile };
